import React from "react";
import PropTypes from "prop-types";

// Style
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./ListingDetails.css";
import { Row, Col, Collapse, Button } from "react-bootstrap";
import cx from "classnames";

//Images
import IconDefault from "/public/SiteIcons/defaultIcon.svg";
import rulesIcon from "/public/SiteIcons/houseRulesArrow.svg";

// Translation
import { injectIntl, FormattedMessage } from "react-intl";
import * as FontAwesome from "react-icons/lib/fa";

import { imageCdnUrl, url } from "../../../config";

import {
  FENCING_HEIGHT_OPTIONS,
  SECURE_DOG_AREA_TYPE,
  GATES_TYPE_OPTIONS,
  SIZE_OF_DOG_OPTIONS,
  NUMBER_OF_DOGS_OPTIONS,
  FENCE_CONDITION_OPTIONS,
} from "../../../constants";

class ListItem extends React.Component {
  static propTypes = {
    itemList: PropTypes.arrayOf(
      PropTypes.shape({
        listsettings: PropTypes.shape({
          itemName: PropTypes.string,
          settingsType: PropTypes.shape({
            typeName: PropTypes.string,
          }),
        }),
        spacesId: PropTypes.string,
      })
    ).isRequired,
    label: PropTypes.string.isRequired,
  };

  static defaultProps = {
    itemList: [],
    showLabel: "Show More Description",
    hideLabel: "Hide Description",
    icon: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState({ open: !this.state.open });
  }

  render() {
    const {
      itemList,
      label,
      showLabel,
      hideLabel,
      icon,
      houseRulesIcon,
      isItemForDog,
    } = this.props;
    const { open } = this.state;

    let count = 4,
      firstArray,
      restArray,
      dotString = false;

    let itemListData;

    if (isItemForDog) {
      itemListData =
        itemList.userSafetyAmenities && itemList.userSafetyAmenities.length > 0
          ? itemList.userSafetyAmenities.filter(
              (o) => o?.listsettings?.isEnable == "1"
            )
          : [];

      const dogAmenities = itemList.dogFriendlyAmenities;

      const mapLabel = (value, options) => {
        const found = options.find(opt => parseInt(opt.value) === parseInt(value));
        return found ? found.label : null;
      };

      const pushIfValid = (value, options, labelPrefix = "") => {
        const label = mapLabel(value, options);
        if (label) {
          itemListData.push({
            listsettings: {
              image: null,
              itemName: labelPrefix + label,
              isEnable: "1",
            },
          });
        }
      };

      if (dogAmenities) {
        if (parseInt(dogAmenities.fencingHeight) === 7 && dogAmenities.fencingDescription) {
          itemListData.push({
            listsettings: {
              image: "fencingHeight.svg",
              itemName: `Fence (${dogAmenities.fencingDescription})`,
              isEnable: "1",
            },
          });
        } else {
          const fencingLabel = mapLabel(dogAmenities.fencingHeight, FENCING_HEIGHT_OPTIONS);
          if (fencingLabel) {
            itemListData.push({
              listsettings: {
                image: "fencingHeight.svg",
                itemName: fencingLabel,
                isEnable: "1",
              },
            });
          }
        }

        if (parseInt(dogAmenities.gatesType) === 8 && dogAmenities.gatesDescription) {
          itemListData.push({
            listsettings: {
              image: "gates.svg",
              itemName: `Gate security (${dogAmenities.gatesDescription})`,
              isEnable: "1",
            },
          });
        } else {
          const gatesDescription = mapLabel(dogAmenities.gatesType, GATES_TYPE_OPTIONS);
          if (gatesDescription) {
            itemListData.push({
              listsettings: {
                image: "gates.svg",
                itemName: gatesDescription,
                isEnable: "1",
              },
            });
          }
        }

        if (parseInt(dogAmenities.fencingHeight) !== 5) {
          if (parseInt(dogAmenities.fenceCondition) === 6 && dogAmenities.fenceType) {
            itemListData.push({
              listsettings: {
                image: "fencingType.svg",
                itemName: `Fence condition (${dogAmenities.fenceType})`,
                isEnable: "1",
              },
            });
          } else {
            const fenceConditionLable = mapLabel(dogAmenities.fenceCondition, FENCE_CONDITION_OPTIONS);
            if (fenceConditionLable) {
              itemListData.push({
                listsettings: {
                  image: "fencingType.svg",
                  itemName: `Fence condition (${fenceConditionLable})`,
                  isEnable: "1",
                },
              });
              }
            }
        }

        const secureAreaLabel = mapLabel(dogAmenities.secureDogAreaType, SECURE_DOG_AREA_TYPE);
        if (secureAreaLabel) {
          itemListData.push({
            listsettings: {
              image: "fencingHeight.svg",
              itemName: `Secure dog area (${secureAreaLabel})`,
              isEnable: "1",
            },
          });
        }


        const sizeOfDog = mapLabel(dogAmenities.sizeOfDog, SIZE_OF_DOG_OPTIONS);
        if (sizeOfDog) {
          itemListData.push({
            listsettings: {
              image: "dogSizeImg.svg",
              itemName: sizeOfDog,
              isEnable: "1",
            },
          });
        }

        const numberOfDogs = mapLabel(dogAmenities.numberOfDogs, NUMBER_OF_DOGS_OPTIONS);
        if (numberOfDogs) {
          itemListData.push({
            listsettings: {
              image: "dogSizeImg.svg",
              itemName: `No. of dogs (${numberOfDogs})`,
              isEnable: "1",
            },
          });
        }

        // pushIfValid(dogAmenities.secureDogAreaType, SECURE_DOG_AREA_TYPE);
        // pushIfValid(dogAmenities.sizeOfDog, SIZE_OF_DOG_OPTIONS);
        // pushIfValid(dogAmenities.numberOfDogs, NUMBER_OF_DOGS_OPTIONS);

        if (dogAmenities.dogBed && parseInt(dogAmenities.dogBed) > 0) {
          itemListData.push({
            listsettings: {
              image: "dogbed.svg",
              itemName: `Dog beds (${dogAmenities.dogBed})`,
              isEnable: "1",
            },
          });
        }

        if (dogAmenities.doggyDoorGap && parseInt(dogAmenities.doggyDoorGap) > 0) {
          itemListData.push({
            listsettings: {
              image: "dogyDoor.svg",
              itemName: `Doggy door (${dogAmenities.doggyDoorGap})`,
              isEnable: "1",
            },
          });
        }
      }
    } else {
      itemListData =
        itemList && itemList.length > 0
          ? itemList.filter((o) => o?.listsettings?.isEnable == "1")
          : [];
    }


    if (itemListData) {
      firstArray = itemListData.slice(0, count);
      restArray = itemListData.slice(count, itemListData.length);
    }
    if (restArray && restArray.length > 0) {
      dotString = true;
    }

    return (
      <div className={cx(s.horizontalLineThrough)}>
        <div className={cx(s.space1)}>
          <p className={cx(s.sectionTitleText)}> {label} </p>
        </div>
        <div className={cx(s.spaceTop1, "listItemFlexContainer")}>
          {firstArray.map((item, key) => {
            if (item.listsettings.isEnable === "1") {
              return (
                <div
                  key={key}
                  className={cx(
                    s.splitList,
                    s.vtrTop,
                    "listItemFlexWrapper"
                  )}
                >
                  {icon && (
                    <span className={cx(s.listIcon, "listIconRtl")}>
                      {item.listsettings.image ? (
                        <img
                          src={
                            imageCdnUrl + "amenities/" + item.listsettings.image
                          }
                          className={cx(s.imgSection, "darkModeFilterNone")}
                        />
                      ) : (
                        <img src={IconDefault} className={cx(s.imgSection)} />
                      )}
                    </span>
                  )}
                  {houseRulesIcon && (
                    <span className="svgImg">
                      <img
                        src={rulesIcon}
                        className={cx(s.rulesIconCss, "rulesIconCssRTL")}
                      />
                    </span>
                  )}
                  <span className={cx(s.text, s.overflowText, s.listContent)}>
                    {item.listsettings && item.listsettings.itemName}
                  </span>
                </div>
              );
            }
          })}
          <Collapse className={cx(s.collapseContainer)} in={open}>
            <div>
              <div className="listCollapseContainer">
                {restArray &&
                  restArray.length > 0 &&
                  restArray.map((item, key) => {
                    if (item.listsettings.isEnable === "1") {
                      return (
                        <p
                          key={key}
                          className={cx(
                            s.splitList,
                            s.vtrTop,
                            "listItemFlexWrapper"
                          )}
                        >
                          {icon && (
                            <span className={cx(s.listIcon, "listIconRtl")}>
                              {item.listsettings.image ? (
                                <img
                                  src={
                                    imageCdnUrl +
                                    "amenities/" +
                                    item.listsettings.image
                                  }
                                  className={cx(
                                    s.imgSection,
                                    "darkModeFilterNone"
                                  )}
                                />
                              ) : (
                                <img
                                  src={IconDefault}
                                  className={cx(s.imgSection)}
                                />
                              )}
                            </span>
                          )}
                          {houseRulesIcon && (
                            <span className="svgImg">
                              <img
                                src={rulesIcon}
                                className={cx(
                                  s.rulesIconCss,
                                  "rulesIconCssRTL"
                                )}
                              />
                            </span>
                          )}
                          <span
                            className={cx(
                              s.text,
                              s.overflowText,
                              s.listContent
                            )}
                          >
                            {item.listsettings && item.listsettings.itemName}
                          </span>
                        </p>
                      );
                    }
                  })}
              </div>
            </div>
          </Collapse>
          {dotString && (
            <div className={cx(s.showHideMargin, "listShowBtn")}>
              <Button
                bsStyle="link"
                type="button"
                className={cx(
                  s.btn,
                  s.btnLink,
                  s.btnLinkSecondary,
                  s.toggleLink,
                  s.showHideBtn,
                  s.noPadding
                )}
                onClick={() => this.handleClick()}
              >
                {this.state.open ? hideLabel : showLabel}
                {this.state.open && (
                  <FontAwesome.FaAngleUp className={s.toggleIcon} />
                )}
                {!this.state.open && (
                  <FontAwesome.FaAngleDown className={s.toggleIcon} />
                )}
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default injectIntl(withStyles(s)(ListItem));
